import { FC, useContext, useEffect, useMemo, useState } from "react";
import Section from "components/kaleido/parts/Section";
import AnchorTarget from "components/official/AnchorTarget";
import Headline from "components/kaleido/long/parts/Headline";
import useKaleidoImagePath from "lib/hooks/kaleido/useImagePath";
import styled from "styled-components";
import { LibraryContext } from "lib/context/kaleido/LibraryContext";
import useObserver from "lib/hooks/kaleido/useObserver";

const Record: FC = () => {
  const [visibleSection, setVisibleSection] = useState<string | null>(null);
  const { imagePath: image } = useKaleidoImagePath("record/");
  const recordImageList = useMemo(() => RECORDS.map((record) => image(`chronology/${record.image}`)), [image]);
  const sectionVisibilityFlags = useObserver(setVisibleSection);
  const isVisible = visibleSection === "record" || sectionVisibilityFlags["record"];
  useSwiper();

  return (
    <StyledSection className={`section ${isVisible ? "visible" : "hidden"}`} id="record">
      <AnchorTarget id="record" />
      <Headline src={"/image/lp/kaleido/record/head.png"} alt="20周年の歩み" />
      <Content>
        <ImageSwiperArea className="recordSection">
          <SwiperButton className="swiper-button-prev" src={image("left.png")} alt="前の年表画像へ" />
          <SwiperContainer className="record swiper">
            <SwiperWrapper className="swiper-wrapper">
              {recordImageList.map((campaignImage, index) => (
                <SwiperSlide className="swiper-slide" key={index}>
                  <ImageContainer>
                    <SlideImage src={campaignImage} />
                  </ImageContainer>
                </SwiperSlide>
              ))}
            </SwiperWrapper>
          </SwiperContainer>
          <SwiperButton className="swiper-button-next" src={image("right.png")} alt="次の年表画像へ" />
        </ImageSwiperArea>
      </Content>
    </StyledSection>
  );
};
export default Record;

const RECORDS = [
  { image: "record_1.jpg" },
  { image: "record_2.jpg" },
  { image: "record_3_mod.jpg" }
];

const useSwiper = () => {
  const defaultIndex = 0;
  const { swiper: swiperReady } = useContext(LibraryContext);
  useEffect(() => {
    if (swiperReady) {
      new window.Swiper(".record.swiper", {
        initialSlide: defaultIndex,
        navigation: {
          prevEl: ".recordSection .swiper-button-prev",
          nextEl: ".recordSection .swiper-button-next",
        },
      });
    }
  }, [swiperReady]);
};

const StyledSection = styled(Section)`
  transition: opacity 0.5s ease-in-out;
  opacity: 0;
  &.visible {
    opacity: 1;
  }
  &.hidden {
    opacity: 0;
  }
  margin-bottom: 12vw;

  @media screen and (min-width: 1281px) {
    margin-bottom: 160px;
  }
`;
const Content = styled.div`
  @media screen and (max-width: 960px) {
    padding: 0 10vw;
  }
`;
const ImageSwiperArea = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2vw;
`;
const SwiperContainer = styled.div`
  @media screen and (max-width: 960px) {
    flex-basis: 100%;
    width: 100%;
    margin-bottom: 30px;
  }
  @media screen and (min-width: 961px) {
    flex-basis: 90%;
    width: 90%;
    margin-bottom: 50px;
    &&.swiper {
      margin-left: 2%;
      margin-right: 2%;
    }
  }
`;
const SwiperWrapper = styled.div``;
const SwiperSlide = styled.div``;
const ImageContainer = styled.div`
  position: relative;
`;
const SlideImage = styled.img`
  width: 100%;
  border: 2px solid lightgray;
  
  @media screen and (min-width: 961px) {
    height: auto;
  }
`;
const SwiperButton = styled.img`
  && {
    color: white;
    z-index: 0;

    &.swiper-button-prev {
      filter: drop-shadow(0 0 2px black);
      width: 26px;
      height: 26px;
      @media screen and (max-width: 960px) {
        position: absolute;
        left: -7vw;
        z-index: 2;
      }
      @media screen and (min-width: 961px) {
        position: static;
      }
    }

    &.swiper-button-next {
      filter: drop-shadow(0 0 2px black);
      width: 26px;
      height: 26px;
      @media screen and (max-width: 960px) {
        position: absolute;
        right: -7vw;
        z-index: 2;
      }
      @media screen and (min-width: 961px) {
        position: static;
      }
    }
  }
`;
